require('../../modules/es6.object.is-extensible');
module.exports = require('../../modules/_core').Object.isExtensible;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/is-extensible.js
// module id = 57
// module chunks = 0